import { SyllabusStateType } from "./types";

export const SyllabusInitialState: SyllabusStateType = {
    courses: {},
    chapters: {},
    modules: {},
    program: {
        programId: '',
        programDesc: '',
        programName: ''
    }
};
